import {
  Box,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  type ModalProps,
} from '@chakra-ui/react';
import { type FC } from 'react';

import { StyledScrollWrapper } from '$/components/common/StyledScrollWrapper';

interface Props extends ModalProps {
  children: React.ReactNode;
  header: string;
  showCloseButton?: boolean;
  isScrollable?: boolean;
}

export const FullModal: FC<Props> = ({
  children,
  header,
  showCloseButton = true,
  isScrollable = true,
  ...modalProps
}) => {
  const content = (
    <Box p='10'>
      <ModalHeader p='0'>
        <Heading mb='4' fontSize='h7'>
          {header}
        </Heading>
        {showCloseButton && <ModalCloseButton top='9' right='9' />}
      </ModalHeader>
      <ModalBody p='0'>{children}</ModalBody>
    </Box>
  );

  return (
    <Modal isCentered size='2xl' {...modalProps}>
      <ModalOverlay />
      <ModalContent gap='4' maxH='90%' borderRadius='12px'>
        {isScrollable ? (
          <StyledScrollWrapper>{content}</StyledScrollWrapper>
        ) : (
          content
        )}
      </ModalContent>
    </Modal>
  );
};
